import { render } from "./HeroSlide.vue?vue&type=template&id=180b5c4a"
import script from "./HeroSlide.vue?vue&type=script&lang=js"
export * from "./HeroSlide.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__